/**
 * Feature switches the shell itself checks. A tenant's switches are its
 * vertical's, overlaid by its product's (education strategy); a switch
 * nobody set is on. The server refuses what these hide.
 */

/** Payments, arrears, payer conversations, collection reports and the bank
 *  collection account. Off for a plan that collects nothing through LipaFlow
 *  (a CBC-only school). */
export const COLLECTIONS = 'collections'

/** The school day (a school's School Operations): only a product sets it, so
 *  a vertical that never does (rental) does not have it. */
export const OPERATIONS = 'operations'

export function collects(features: Record<string, boolean | undefined>): boolean {
  return features[COLLECTIONS] !== false
}
